import React from 'react'
import styles from './styles.module.css'
import GanttChart from './components/ganttChart/GanttChart'
import PropTypes from 'prop-types'

const ReactGanttchartPlanner = ({
  shifts,
  tasksArray,
  durationsArray,
  resourcesArray
}) => {
  return (
    <GanttChart
      shifts={shifts}
      tasksArray={tasksArray}
      durationsArray={durationsArray}
      resourcesArray={resourcesArray}
    />
  )
}
ReactGanttchartPlanner.defaultProps = {
  shifts: 4,
  tasksArray: [],
  durationsArray: [],
  resourcesArray: []
}

ReactGanttchartPlanner.propTypes = {
  shifts: PropTypes.number,
  tasksArray: PropTypes.array,
  durationsArray: PropTypes.array,
  resourcesArray: PropTypes.array
}
export default ReactGanttchartPlanner
